$(function () {
    var fontSizeInitial = parseInt($('#uberMain').css('font-size')),
        fontSize = fontSizeInitial,
        resizeToolbar = $('.resizeText'),
        resizeToolbarBtns = resizeToolbar.find('button, a[role="button"]');

    resizeToolbarBtns.on('click', function (event) {
        event.preventDefault();
        resizeToolbarBtns.removeClass('current');
        resizeToolbarBtns.attr('aria-selected', false);
        if (iCreateObject.isSiteInICreateMode) {
            showNAMessage();
        } else {
            var sizer = $(this);
            if (sizer.hasClass('textDefault')) {
                fontSize = fontSizeInitial;
                resizeText(fontSize);
                sizer.addClass('current');
            } else if (sizer.hasClass('textDecrease') && fontSize > 8) {
                fontSize--;
                resizeText(fontSize);
            } else if (sizer.hasClass('textIncrease') && fontSize < 24) {
                fontSize++;
                resizeText(fontSize);
            } else if (sizer.hasClass('textLarge') && fontSize < 24) {
                fontSize = fontSizeInitial + 2;
                resizeText(fontSize);
                sizer.addClass('current');
            } else if (sizer.hasClass('textXLarge') && fontSize < 24) {
                fontSize = fontSizeInitial + 4;
                resizeText(fontSize);
                sizer.addClass('current');
            }
            $(this).attr('aria-selected', true);
        }
    });
});

function resizeText(size) {
    $('#uberMain').css('font-size', size);
    $('#printArea').css('font-size', size);
    $('#printArea .datatable .titlerow').css('font-size', size);
    $('.Accordion .AccordionTrigger *').css('font-size', size);
    $('.Accordion .AccordionContent').css('font-size', size);
    $('.Accordion .AccordionTitle').css('font-size', size);
    $('.icHowto').css('font-size', size);
    if ($('#uber').hasClass('interior')) {
        $.fn.matchHeight._update();
    }
}
